import React, { useState, useEffect, useRef } from "react";
import {useNavigate, useLocation} from "react-router-dom";
import logo from "../assets/logo.png";
import { useAuth } from "../context/AuthContext";
import { FaUserCircle } from "react-icons/fa";
import "./Header.css";
import ChangePasswordModal from "../pages/ChangePasswordModal";



const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const [showChangePassword, setShowChangePassword] = useState(false);

const hideLoginButton =
  location.pathname.startsWith("/survey/") ||
  location.pathname === "/login" ||
  location.pathname === "/survey-completed" ||
  location.pathname === "/thank-you" ||
  location.pathname === "/" ||
  location.pathname === "/expired" ||
  location.pathname === "/5s-result" ||
  location.pathname === "/vak-survey-result"||
  location.pathname === "/cpq-result" ||
  location.pathname === "/ems-result" ||
  location.pathname === "/jh-result" ||
  location.pathname === "/tk-result" ||
  location.pathname === "/ao-result" ||
  location.pathname === "/ns-result" ||
  location.pathname === "/loco-results";

  const hideprofileIcon =
  location.pathname.startsWith("/survey/") ||
  location.pathname === "/5s-result" ||
  location.pathname === "/vak-survey-result"||
  location.pathname === "/cpq-result" ||
  location.pathname === "/ems-result" ||
  location.pathname === "/jh-result" ||
  location.pathname === "/tk-result" ||
  location.pathname === "/ao-result" ||
  location.pathname === "/ns-result" ||
  location.pathname === "/loco-results";

  const handleLoginClick = () => navigate("/login");
  const handleLogoutClick = () => {
    logout();
    navigate("/login");
  };
  const handleAddSurveyClick = () => {
  navigate("/add-survey");
};


  // 🔹 Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="header-container">
      <header className="header">
        {/* <Link to="/">
          <img src={logo} alt="Logo" className="header-logo" />
        </Link> */}
           <img src={logo} alt="Logo" className="header-logo" />

        <div className="header-right">


{!user && !hideLoginButton ? (
  <button onClick={handleLoginClick} className="login-btn">
    Login
  </button>
) : user && !hideprofileIcon ? (
  <>
    {/* ➕ Add Survey button */}
    <button
      className="add-survey-btn"
      onClick={handleAddSurveyClick}
    >
      + Add Survey
    </button>

    <div className="profile-container" ref={dropdownRef}>
      <div
        className="profile-info"
        onClick={() => setShowMenu((prev) => !prev)}
      >
        {user.companyName && (
          <span className="company-name">{user.companyName}</span>
        )}
        <FaUserCircle className="profile-icon" />
      </div>

      {showMenu && (
        <div className="profile-dropdown">
          <span className="user-email">{user.email}</span>

          <button
            className="profile-action"
            onClick={() => {
              setShowChangePassword(true);
              setShowMenu(false);
            }}
          >
            🔑 Change Password
          </button>

          <button className="logout-btn" onClick={handleLogoutClick}>
            🚪 Logout
          </button>
        </div>
      )}

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  </>
) : null}

        </div>
      </header>

      <div className="header-divider"></div>
    </div>
  );
};

export default Header;
